export const filterData = {
  'show-all': {
    icon: 'i-bolt tw-opacity-0',
    hideIcon: true,
  },
  todos: {
    icon: 'i-bolt tw-text-sf-success',
    hideIcon: false,
  },
  checks: {
    icon: 'i-square tw-text-sf-primary',
    hideIcon: false,
  },
  unreconciled: {
    icon: 'i-unreconciled sf-c-danger',
    hideIcon: false,
  },
  unreviewed_by_me: {
    icon: 'workflows/crossed_check.svg',
    hideIcon: false,
  },
  starred: {
    icon: 'fa fa-star sf-c-warning',
    hideIcon: false,
  },
}
